import { Route } from '@angular/router';
import { createAuthGuard } from 'keycloak-angular';
import { authGuard } from './core/guards/auth.guard';

export const appRoutes: Route[] = [
  {
    path: 'inicio',
    loadComponent: () => import('./modules/home/home.page').then((m) => m.HomePage),
    data: {
      title: 'Inicio',
    },
  },
  {
    path: 'cuenta',
    loadChildren: () => import('./modules/account/account.module').then((m) => m.AccountModule),
    canActivate: [createAuthGuard(authGuard)],
  },
  {
    path: 'carrito',
    loadChildren: () => import('./modules/cart/cart.module').then((m) => m.CartModule),
  },
  {
    path: 'juegos',
    loadChildren: () => import('./modules/games/games.module').then((m) => m.GamesModule),
  },
  {
    path: 'noticias',
    loadChildren: () => import('./modules/noticias/noticias.routes').then((m) => m.noticiasRoutes),
    data: { title: 'Noticias' },
  },
  {
    path: 'institucional',
    loadChildren: () => import('./modules/institutional/institutional.routes').then((m) => m.institutionalRoutes),
    data: { title: 'Institucional' },
  },
  {
    path: 'ayuda',
    loadChildren: () => import('./modules/help/help.routes').then((m) => m.helpRoutes),
    data: { title: 'Ayuda' },
  },
  {
    path: 'politicas',
    loadChildren: () => import('./modules/politicas/politicas.routes').then((m) => m.politicasRoutes),
    data: { title: 'Políticas' },
  },
  {
    path: 'juego-responsable',
    loadChildren: () =>
      import('./modules/juego-responsable/juego-responsable.routes').then((m) => m.juegoResponsableRoutes),
    data: { title: 'Juego Responsable' },
  },
  {
    path: 'raspaditas-fisicas',
    loadChildren: () =>
      import('./modules/raspaditas-fisicas/raspaditas-fisicas.routes').then((m) => m.raspaditasFisicasRoutes),
    data: { title: 'Raspaditas Físicas' },
  },
  {
    path: 'cabalas',
    loadChildren: () => import('./modules/cabalas/cabalas.routes').then((m) => m.cabalasRoutes),
    data: { title: 'Cábalas' },
  },
  {
    path: 'eticket',
    loadChildren: () => import('./modules/eticket/eticket.routes').then((m) => m.eticketRoutes),
    data: { title: 'Consulta de eTicket' },
  },
  {
    path: 'postulacion',
    loadChildren: () => import('./modules/postulacion/postulacion.routes').then((m) => m.postulacionRoutes),
    data: { title: 'Solicitud de habilitación' },
  },
  {
    path: 'contacto',
    loadChildren: () => import('./modules/contacto/contacto.routes').then((m) => m.contactoRoutes),
    data: { title: 'Contacto' },
  },
  {
    path: 'pdf',
    loadComponent: () => import('./modules/pdf-viewer/pdf-viewer.component').then((m) => m.PdfViewerComponent),
    data: { title: 'Documento' },
  },
  {
    path: 'loadingDeposit',
    loadComponent: () =>
      import('./modules/account/components/deposit/loading-deposit/loading-deposit.component').then(
        (m) => m.LoadingDepositComponent
      ),
    data: { title: 'Procesando depósito' },
  },
  {
    path: 'login',
    redirectTo: 'inicio',
    pathMatch: 'full',
  },
  {
    path: 'home',
    redirectTo: 'inicio',
    pathMatch: 'full',
  },
  {
    path: '',
    redirectTo: 'inicio',
    pathMatch: 'full',
  },
];
